// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Legacy global helpers: other pages (assets, tasks, rooms, departments) use .full-width and
   rely on the 200px Quill height, so these stay unscoped. */
.Contactclass td.ant-table-cell {
  cursor: pointer;
}
.contractInput {
  width: 70%;
  border-top: 0px;
  border-right: 0px;
  border-left: 0px;
  border-radius: 0px;
}

.contractInput2 {
  width: 50%;
  border-top: 0px;
  border-right: 0px;
  border-left: 0px;
  border-radius: 0px;
}

.contractRow {
  padding-top: 20px;
}
.ql-container.ql-snow {
  height: 200px;
}
.full-width {
  width: 100%;
  height: 32px;
}

.unit-width {
  width: 60;
}

/* Contract type picker */
.contract-type-card {
  height: 100%;
  border-width: 1.5px;
}
.contract-type-card.is-selected {
  border-color: var(--ds-brand);
  box-shadow: 0 0 0 1px var(--ds-brand);
}
.contract-type-card__desc {
  margin-top: var(--ds-space-1);
  font-size: 12.5px;
  color: var(--ds-text-2);
  overflow-wrap: anywhere;
}

/* Contract text editor; overrides the global 200px Quill height above */
.contract-editor .ql-container.ql-snow {
  height: 52vh;
  min-height: 320px;
  font-size: 14px;
}
.contract-editor--template .ql-container.ql-snow {
  height: 46vh;
}
@media (max-width: 767.98px) {
  .contract-editor .ql-container.ql-snow,
  .contract-editor--template .ql-container.ql-snow {
    height: 60vh;
    height: 60dvh;
    min-height: 280px;
  }
}
.contract-editor .ql-toolbar.ql-snow {
  display: flex;
  flex-wrap: wrap;
  row-gap: var(--ds-space-1);
}
.contract-placeholder {
  cursor: pointer;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 11.5px;
  padding-block: var(--ds-space-1);
  overflow-wrap: anywhere;
  white-space: normal;
}
.contract-legal-note {
  font-size: 12px;
}

/* Contract page */
.contract-details__header {
  min-width: 0;
}
.contract-details__title {
  overflow-wrap: anywhere;
}
.contract-paper {
  box-shadow: var(--ds-shadow-xs);
}
@media (max-width: 767.98px) {
  .contract-details .contract-paper > .ant-card-body {
    padding: var(--ds-space-3);
  }
  .contract-details .contract-paper__body.ql-editor {
    padding: var(--ds-space-1) 0;
  }
}
.contract-paper__body.ql-editor {
  /* ql-editor gives Quill's alignment and indent classes their meaning; undo its editor bits */
  height: auto;
  overflow: visible;
  padding: 8px 12px;
  line-height: 1.6;
  font-size: 14px;
  max-width: 820px;
  margin: 0 auto;
  overflow-wrap: anywhere;
}
.contract-paper__body img,
.contract-paper__body table {
  max-width: 100%;
}
.contract-paper__body h1 {
  font-size: 22px;
  margin-bottom: 16px;
}
.contract-paper__body h3 {
  font-size: 15px;
  margin-top: 18px;
}
.contract-signature + .contract-signature {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid var(--ds-border-soft);
}
.contract-signature__img {
  display: block;
  max-width: 100%;
  max-height: 90px;
  margin: 6px 0;
  border-bottom: 1px solid var(--ds-border);
  /* The signature PNG is dark ink on transparent: keep a light backing in dark themes. */
  background: #fff;
}
.contract-signature__meta {
  font-size: 12px;
}

/* Signature pad */
.signature-pad__area {
  position: relative;
  border: 1px dashed var(--ds-border);
  border-radius: var(--ds-radius-sm);
  /* Light in every theme: the ink colour is fixed dark (see SignaturePad.jsx). */
  background: #fff;
  overflow: hidden;
}
.signature-pad__area canvas {
  display: block;
  touch-action: none;
  cursor: crosshair;
}
.signature-pad__baseline {
  position: absolute;
  inset-inline: var(--ds-space-4);
  bottom: 36px;
  border-bottom: 1px solid var(--ds-border);
  font-size: 12px;
  color: var(--ds-text-muted);
  pointer-events: none;
  line-height: 1;
}

/* Contract typography, shared by the editor and the contract page */
.contract-editor .ql-editor p,
.contract-paper__body p {
  margin-bottom: 6px;
}
.contract-editor .ql-editor h1,
.contract-editor .ql-editor h2,
.contract-editor .ql-editor h3,
.contract-paper__body h1,
.contract-paper__body h2,
.contract-paper__body h3 {
  font-weight: 600;
}
.contract-editor .ql-editor h3,
.contract-paper__body h3 {
  margin-top: 14px;
  margin-bottom: 4px;
}

.signature-pad__clear {
  min-height: 40px;
  padding-inline: 0;
}

/* Contract form modal: steps and footer on phones */
.contract-form-modal__footer {
  width: 100%;
}
@media (max-width: 767.98px) {
  .contract-form-modal .contract-form-modal__steps .ant-steps-item-title {
    font-size: 12px;
    line-height: 1.3;
  }
}
@media (max-width: 767.98px) {
  .contract-templates .contract-placeholder {
    display: inline-flex;
    align-items: center;
    min-height: 40px;
  }
}
[dir="rtl"] .contract-details .contract-details__back .anticon {
  transform: scaleX(-1);
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/contracts/Contracts.css"],"names":[],"mappings":"AAAA;4DAC4D;AAC5D;EACE,eAAe;AACjB;AACA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,qCAAqC;AACvC;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,wEAAwE;AACxE;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE;;IAEE,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;AACF;AACA;EACE,aAAa;EACb,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,2DAA2D;EAC3D,iBAAiB;EACjB,gCAAgC;EAChC,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA;EACE,+BAA+B;AACjC;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,6FAA6F;EAC7F,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;AAC7C;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,yCAAyC;EACzC,uFAAuF;EACvF,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;EAClC,+EAA+E;EAC/E,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,yCAAyC;EACzC,eAAe;EACf,2BAA2B;EAC3B,oBAAoB;EACpB,cAAc;AAChB;;AAEA,oEAAoE;AACpE;;EAEE,kBAAkB;AACpB;AACA;;;;;;EAME,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,oDAAoD;AACpD;EACE,WAAW;AACb;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE;IACE,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;EAClB;AACF;AACA;EACE,qBAAqB;AACvB","sourcesContent":["/* Legacy global helpers: other pages (assets, tasks, rooms, departments) use .full-width and\n   rely on the 200px Quill height, so these stay unscoped. */\n.Contactclass td.ant-table-cell {\n  cursor: pointer;\n}\n.contractInput {\n  width: 70%;\n  border-top: 0px;\n  border-right: 0px;\n  border-left: 0px;\n  border-radius: 0px;\n}\n\n.contractInput2 {\n  width: 50%;\n  border-top: 0px;\n  border-right: 0px;\n  border-left: 0px;\n  border-radius: 0px;\n}\n\n.contractRow {\n  padding-top: 20px;\n}\n.ql-container.ql-snow {\n  height: 200px;\n}\n.full-width {\n  width: 100%;\n  height: 32px;\n}\n\n.unit-width {\n  width: 60;\n}\n\n/* Contract type picker */\n.contract-type-card {\n  height: 100%;\n  border-width: 1.5px;\n}\n.contract-type-card.is-selected {\n  border-color: var(--ds-brand);\n  box-shadow: 0 0 0 1px var(--ds-brand);\n}\n.contract-type-card__desc {\n  margin-top: var(--ds-space-1);\n  font-size: 12.5px;\n  color: var(--ds-text-2);\n  overflow-wrap: anywhere;\n}\n\n/* Contract text editor; overrides the global 200px Quill height above */\n.contract-editor .ql-container.ql-snow {\n  height: 52vh;\n  min-height: 320px;\n  font-size: 14px;\n}\n.contract-editor--template .ql-container.ql-snow {\n  height: 46vh;\n}\n@media (max-width: 767.98px) {\n  .contract-editor .ql-container.ql-snow,\n  .contract-editor--template .ql-container.ql-snow {\n    height: 60vh;\n    height: 60dvh;\n    min-height: 280px;\n  }\n}\n.contract-editor .ql-toolbar.ql-snow {\n  display: flex;\n  flex-wrap: wrap;\n  row-gap: var(--ds-space-1);\n}\n.contract-placeholder {\n  cursor: pointer;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 11.5px;\n  padding-block: var(--ds-space-1);\n  overflow-wrap: anywhere;\n  white-space: normal;\n}\n.contract-legal-note {\n  font-size: 12px;\n}\n\n/* Contract page */\n.contract-details__header {\n  min-width: 0;\n}\n.contract-details__title {\n  overflow-wrap: anywhere;\n}\n.contract-paper {\n  box-shadow: var(--ds-shadow-xs);\n}\n@media (max-width: 767.98px) {\n  .contract-details .contract-paper > .ant-card-body {\n    padding: var(--ds-space-3);\n  }\n  .contract-details .contract-paper__body.ql-editor {\n    padding: var(--ds-space-1) 0;\n  }\n}\n.contract-paper__body.ql-editor {\n  /* ql-editor gives Quill's alignment and indent classes their meaning; undo its editor bits */\n  height: auto;\n  overflow: visible;\n  padding: 8px 12px;\n  line-height: 1.6;\n  font-size: 14px;\n  max-width: 820px;\n  margin: 0 auto;\n  overflow-wrap: anywhere;\n}\n.contract-paper__body img,\n.contract-paper__body table {\n  max-width: 100%;\n}\n.contract-paper__body h1 {\n  font-size: 22px;\n  margin-bottom: 16px;\n}\n.contract-paper__body h3 {\n  font-size: 15px;\n  margin-top: 18px;\n}\n.contract-signature + .contract-signature {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid var(--ds-border-soft);\n}\n.contract-signature__img {\n  display: block;\n  max-width: 100%;\n  max-height: 90px;\n  margin: 6px 0;\n  border-bottom: 1px solid var(--ds-border);\n  /* The signature PNG is dark ink on transparent: keep a light backing in dark themes. */\n  background: #fff;\n}\n.contract-signature__meta {\n  font-size: 12px;\n}\n\n/* Signature pad */\n.signature-pad__area {\n  position: relative;\n  border: 1px dashed var(--ds-border);\n  border-radius: var(--ds-radius-sm);\n  /* Light in every theme: the ink colour is fixed dark (see SignaturePad.jsx). */\n  background: #fff;\n  overflow: hidden;\n}\n.signature-pad__area canvas {\n  display: block;\n  touch-action: none;\n  cursor: crosshair;\n}\n.signature-pad__baseline {\n  position: absolute;\n  inset-inline: var(--ds-space-4);\n  bottom: 36px;\n  border-bottom: 1px solid var(--ds-border);\n  font-size: 12px;\n  color: var(--ds-text-muted);\n  pointer-events: none;\n  line-height: 1;\n}\n\n/* Contract typography, shared by the editor and the contract page */\n.contract-editor .ql-editor p,\n.contract-paper__body p {\n  margin-bottom: 6px;\n}\n.contract-editor .ql-editor h1,\n.contract-editor .ql-editor h2,\n.contract-editor .ql-editor h3,\n.contract-paper__body h1,\n.contract-paper__body h2,\n.contract-paper__body h3 {\n  font-weight: 600;\n}\n.contract-editor .ql-editor h3,\n.contract-paper__body h3 {\n  margin-top: 14px;\n  margin-bottom: 4px;\n}\n\n.signature-pad__clear {\n  min-height: 40px;\n  padding-inline: 0;\n}\n\n/* Contract form modal: steps and footer on phones */\n.contract-form-modal__footer {\n  width: 100%;\n}\n@media (max-width: 767.98px) {\n  .contract-form-modal .contract-form-modal__steps .ant-steps-item-title {\n    font-size: 12px;\n    line-height: 1.3;\n  }\n}\n@media (max-width: 767.98px) {\n  .contract-templates .contract-placeholder {\n    display: inline-flex;\n    align-items: center;\n    min-height: 40px;\n  }\n}\n[dir=\"rtl\"] .contract-details .contract-details__back .anticon {\n  transform: scaleX(-1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
